import React from "react";
import {
  Box,
  Container,
  Heading,
  Text,
  VStack,
  useColorModeValue,
} from "@chakra-ui/react";

const TermsOfService = () => {
  const bgColor = useColorModeValue("white", "gray.800");
  const textColor = useColorModeValue("gray.600", "gray.300");

  const sections = [
    {
      title: "제 1조 (목적)",
      content: `이 약관은 (주)루나르트(이하 '회사'라 한다)가 제공하는 서비스 플플(이하 '서비스'라 한다)의 이용과 관련하여 회사와 이용자 간의 권리와 의무, 책임사항 및 기타 필요한 사항을 규정함을 목적으로 합니다.`,
    },
    {
      title: "제 2조 (용어의 정의)",
      content: `① 본 약관에서 사용하는 용어는 다음과 같습니다.
1. 회원 : 회사가 운영하는 사이트에 접속하여 이 약관에 동의하고, 회사와 이용계약을 체결하여 아이디와 비밀번호를 발급받아 사이트를 이용하는 이용자를 말합니다.
2. 이용자 : 회원에 가입하지 아니한 상태로 사이트에 접속하여 이용을 하는 자(회원, 비회원 포함)를 의미합니다 (사이트 사용에 제한이 있습니다).
3. 아이디 : 회원의 식별과 서비스 이용을 위하여 회원이 선정하고 회사가 사용을 승인하여 부여한 문자 또는 숫자의 조합을 말합니다.
4. 비밀번호 : 회원이 부여 받은 아이디와 일치된 회원임을 확인하고, 회원의 개인정보를 보호하기 위하여 회원이 정한 문자와 숫자의 조합을 의미합니다.
5. 디지털 음원 사이트 : 음악을 스트리밍 및 다운로드 혹은 그에 준하는 형태로 온라인에서 음악을 청취 할 수 있는 웹사이트를 의미합니다.
6. 음반 : 회사가 운영하는 사이트에서 판매 및 거래하는 음악, 트랙, 앨범 등의 음악 콘텐츠를 통칭합니다.
7. 저작권 및 저작인접권의 저작재산권 : 회사가 운영하는 사이트에서 거래하는 음반의 소유권 및 재산적 권리를 의미합니다.
8. 스트리밍 로열티 권리 : 회사가 운영하는 사이트에서 거래하는 음반의 일부 권리로서, 음반에서 발생하는 저작인접권료에 대한 권리를 의미합니다.
9. 발매 : 회사가 운영하는 사이트의 등록 된 음반이 디지털 음악으로 디지털 음원 사이트에 공개되는 것을 의미합니다.
10. 플플 멤버십 : 회사가 회원에게 제공하는 서비스의 하나로서, 회원이 매월 회사에서 제시하는 금액을 결제하고, 회사는 회원에게 매월 4개의 음반을 멤버십 구독기간 동안 대여하는 것을 의미합니다. 회원은 회사에게 제공받은 음반을 활용하여 플레이리스트를 제작하여 유튜브 채널에 업로드를 요청할 수 있으며, 회사는 요청한 회원에게 회사에서 정한 일정 금액을 추가로 지급받고 플레이리스트 제작 및 업로드 서비스를 제공하는 것을 뜻합니다.
11. 리슨 : 뮤지션이 사이트에 음악을 등록하고, 플레이리스트 크리에이터에게 이용 허락을 함으로써 플레이리스트 크리에이터가 자신의 플레이리스트에 자유롭게 수록할 수 있도록 사이트에서 제공하는 서비스를 의미합니다.
12. 리슨 플러스(PLUS) : 뮤지션이 리슨에 등록한 음악을 뮤지션이 선택하는 특정 채널 및 플레이리스트 크리에이터에게 직접 음악 청취를 제안하는 서비스를 의미합니다. 리슨 플러스에 등록된 음악을 플레이리스트 크리에이터가 자신의 플레이리스트에 수록할 경우, 뮤지션은 자신이 보유하고 있는 캐시로 플레이리스트 크리에이터에게 리워드를 지급해야 합니다.
13. 피칭 : 뮤지션이 플레이리스트 크리에이터에게 리슨 플러스를 통해 자신의 음악을 플레이리스트에 수록 제안하는 것을 의미합니다.
14. 포크(Poke) : 플레이리스트 크리에이터가 뮤지션에게 리슨 플러스에 등록되어 있지만, 자신이 제안받지 않은 리슨 플러스 음악을 자신의 플레이리스트에 수록하고 리워드를 받겠다고 제안하는 것을 의미합니다. 제안받은 뮤지션이 포크를 수락할 경우, 플레이리스트 크리에이터는 자신의 플레이리스트에 수록하고 리워드를 받을 수 있습니다.
15. 월렛 : 뮤지션이 사이트의 각종 서비스를 사용하기 위한 캐시를 보관하는 온라인 기능 및 공간을 의미합니다.
16. 캐시 : 뮤지션이 리슨 플러스를 포함한 사이트의 기능을 사용할 수 있는 수단입니다.
17. 리워드 : 플레이리스트 크리에이터가 리슨 플러스 음악을 자신의 플레이리스트에 수록함으로서 지급받는 보상입니다.
18. 플레이리스트 크리에이터(이하 '크리에이터') : 음악 스트리밍 플랫폼 및 영상 플랫폼을 비롯한 각종 온/오프라인 매체에서 플레이리스트를 기획, 제작, 게시 등의 활동을 하며 소위 '음악 인플루언서', '플레이리스터', '큐레이터', 'DJ(디제이)', '에디터', '플레이리스트 크리에이터', '플레이리스트 메이커' 등으로 알려진 당사자 본인(개인/그룹), 또는 협력, 대행, 권한 위임 등의 목적으로 해당 당사자와의 계약 관계를 통해 해당 당사자와의 콘텐츠를 대변할 수 있는 적법한 주체로서, 사이트에서 크리에이터로 활동하는 회원을 의미합니다.
19. 뮤지션 : 디지털 형태의 음원파일을 비롯한 특정 음악 창작물의 소위 "메인 뮤지션"으로서 당사자 본인(개인/그룹), 또는 매니지먼트, 기획사, 레이블, 엔터테인먼트, 유통사, 마케팅 대행사 등으로 표현되며 음반 소유, 제작, 유통, 홍보, 프로모션 등의 목적으로 해당 당사자와의 계약 관계를 통해 해당 당사자와 관련 음악 창작물을 대변할 수 있는 적법한 주체로서, 사이트에서 뮤지션 회원으로 활동하는 회원을 의미합니다.
20. 데이터랩 : 사이트가 음악 산업, 플레이리스트 산업, 플레이리스트 콘텐츠 관련 된 데이터를 회원에게 제공하는 서비스를 의미합니다.
21. 채널영향력 (CPI, Channel Power Index) : 회사에서 플레이리스트 채널의 영향력을 측정하기 위해 자체 개발한 평가 모델을 바탕으로 데이터랩을 통해 제공되는 플레이리스트 채널의 영향력 지표를 의미합니다.
22. 영상영향력 (PPI, Playlist Performance Index) : 회사에서 플레이리스트 영상의 영향력을 측정하기 위해 자체 개발한 평가 모델을 바탕으로 데이터랩을 통해 제공되는 플레이리스트의 영향력 지표를 의미합니다.
23. (플레이리스트) 채널 : 각종 음악 스트리밍 플랫폼 및 영상 플랫폼에서 플레이리스트 콘텐츠를 제작하는 개인 및 회사 혹은 단체의 플레이리스트 게재 창구를 의미합니다.
24. 구독자 : 플레이리스트 채널을 구독하는 대중을 의미합니다.
25. 플레이리스트 : 창작자, 자신의 사상이나 감정을 표현하기 위해 자신의 음악 성향 및 취향에 부합하는 단일 음악 혹은 복수의 음악을 목록으로 구성하고, 이를 초단위로 배치한 후 이에 어울리는 시각적인 문화 요소를 플레이리스트 전면에 배치하여 제작한 후, 모든 구성 요소와 사상 및 감정을 하나의 문구로 표현한 작품을 의미합니다.
26. 온디맨드(On-demand) 플레이리스팅 서비스 : 리슨 혹은 리슨 플러스에 등록 된 음악들이 등록한 회원에 의해 플레이리스트 수록이 결정되지 않고, 등록 된 음악을 플레이리스트 크리에이터가 듣고 자율적이고 주체적으로 플레이리스트 수록을 결정하는 서비스를 말합니다.
27. 매거진 : 사이트에서 제공되는 아티클, 교육 자료, 각종 지표 자료 등 플레이리스트와 관련된 내용이 게재된 사이트의 공간을 의미합니다.
② 본 약관에서 사용하는 용어의 정의는 본조에서 정하는 것을 제외하고 관계 법령, 서비스별 약관 내지 계약서 등에서 정하는 바에 의하며, 관계 법령과 서비스별 약관에서 정하지 아니한 것은 일반적인 상관례에 따릅니다.`,
    },
    {
      title: "제 3조 (약관의 효력 및 변경)",
      content: `① 회사는 본 약관의 내용과 상호, 영업소 소재지, 대표자의 성명, 사업자 등록번호, 연락처(전화, 팩스, 전자우편주소) 등을 회원이 알 수 있도록 회사에서 운영하는 사이트 홈페이지(www.plpl.kr) 초기화면 또는 연결화면에 공지하여야 하며, 본 약관은 이로써 효력이 발생합니다.
② 이 약관에 동의하고 회원가입을 한 회원은 동의한 시점부터 본 약관의 적용을 받고, 약관이 개정된 경우에는 개정된 약관의 효력이 발생하는 시점부터 개정된 약관의 적용을 받습니다.
③ 회사는 필요하다고 인정되는 경우 이 약관을 변경할 수 있습니다. 회사는 약관이 변경되는 경우에 변경된 약관의 내용과 적용일을 정하여, 그 적용일로부터 7일전까지 홈페이지에 온라인으로 공시하거나 회원의 이메일로 전송하는 방법으로 회원에게 고지합니다. 단, 회원의 권리, 의무에 중대한 영향을 주는 변경의 경우에는 적용일자 30일 전부터 공지합니다.
④ 회원은 개정되는 약관의 전체 또는 일부의 내용에 동의하지 않을 권리가 있습니다. 본 약관의 변경에 대해 이의가 있는 회원은 이용을 중단하고 이용계약을 해지(회원탈퇴) 할 수 있습니다. 다만, 이용계약이 해지되면 로그인 후 제공되는 서비스를 이용할 수 없게 됩니다.
⑤ 회사가 전항에 따라 개정 약관에 대한 변경 동의 의사가 표명된 것으로 본다는 뜻을 명확하게 고지하였음에도 회원이 명시적으로 거부의 의사표시를 하지 아니한 경우 회원이 변경 약관에 동의한 것으로 봅니다.`,
    },
    {
      title: "제 4조 (약관의 적용 및 이외 준칙)",
      content: `① 회사는 음악저작권의 양수 및 음원 유통 등과 관련하여 별도의 이용계약서를 체결할 수 있으며, 해당 내용이 본 약관과 상충할 경우에는 별도의 이용계약서가 우선하여 적용됩니다.
② 본 약관에 명시되지 아니한 사항과 본 약관의 해석에 관하여는 "약관의 규제에 관한 법률(이하 '약관규제법')", "정보통신망이용촉진및정보보호에관한법률(이하 '정보통신망법')"등 관계법령에 의합니다.`,
    },
    {
      title: "제 5조 (이용계약의 체결)",
      content: `① 이용계약은 이용자가 본 약관의 내용에 동의를 하고, 회사가 제시하는 양식과 절차에 따라 회원가입 신청을 하여, 회사가 이러한 신청에 대하여 승인하여 회원가입 절차가 완료됨으로써 체결됩니다. 
② 회원이 되고자 하는 자는 홈페이지를 통해 가입 시, 본 약관에 대해 "동의함" 박스에 체크하거나 버튼을 클릭함으로써 본 약관에 대한 동의의 의사표시를 하여야 합니다.
③ 이용계약이 체결되면 회사는 회원과의 사전 협의 후, 회원 아이디를 부여합니다. 회원 아이디는 원칙적으로 변경이 불가능하며, 불가피한 사유로 인하여 변경하고자 하는 경우에는 해당 아이디를 해지하고 새로운 아이디를 부여 받아야 합니다.
④ 전항의 회원 아이디를 부여하는 과정에서 회사는 회원의 정보를 확인하는 차원에서 해당 회원이 기입하는 이메일 주소, 번호인증 등에 대한 인증절차를 진행할 수 있습니다.`,
    },
    {
      title: "제 6조 (이용계약 사항의 변경)",
      content: `① 회원은 다음 각호 해당하는 사유가 발생한 경우에는 사유 발생 즉시 이메일 또는 회사의 안내에 따라 변경사항을 회사에 알리고 계약의 변경을 요청하여야 합니다.
1. 고객의 성명, 주소 또는 연락처의 변경
2. 그 밖에 회사를 통한 음악저작권의 양도 및 유통업무에 영향을 줄 수 있는 사정의 발생 내지 변경
② 회사는 회원이 제1항의 변경사항을 회사에 알리지 않아 발생한 불이익에 대하여 책임지지 않습니다.`,
    },
    {
      title: "제 7조 (이용계약의 승인과 제한)",
      content: ` ① 회사는 이용자가 적법한 절차에 정확한 정보를 이용하여 회원가입신청을 하고 회사가 업무와 기술상에 문제가 없을 경우, 위 신청을 승낙함을 원칙으로 합니다. 단, 회사는 다음 각 호에 해당하는 회원가입 신청에 대해서는 승낙하지 아니하거나, 승낙을 유보할 수 있습니다.
1. 실명이 아니거나 타인의 명의를 이용하여 신청한 경우
2. 회사가 제시하는 양식 및 내용을 기재하지 아니한 경우
3. 이용자가 본 약관을 위반하여 이전에 회원자격을 상실한 적이 있는 경우(단, 회원자격의 상실 후 3년이 경과한 자로서 회사의 재가입승낙을 얻은 경우에는 예외로 합니다)
4. 회사에 피해를 입히거나 부정하게 영리를 추구할 목적으로 서비스를 이용하고자 하는 경우
5. 회사의 설비, 기술상 문제가 있는 등 기타 부득이한 사유로 승인이 곤란한 경우
② 회사는 회원이 다음 각 호의 하나에 해당하는 행위를 하였을 경우 서비스 이용을 제한하거나 이용계약을 해지할 수 있습니다.
 1. 타인의 개인정보, 이용자ID 및 비밀번호를 부정하게 사용하는 경우
 2. 타인의 명예를 손상시키거나 불이익을 주는 행위를 한 경우
 3. 회사의 서비스 정보를 이용하여 얻은 정보를 회사의 사전 승낙 없이 복제 또는 유통시키거나 상업적으로 이용하는 경우
 4. 회사, 다른 회원 또는 제3자의 지적재산권을 침해하는 경우
 5. 회사로부터 구입한 음원 또는 회사를 통해 발매한 음원에 대하여 음악산업진흥에관한법률 제26조에서 금하고 있는 행위를 하는 경우
 6. 공공기관의 시정 요구가 있는 경우
 7. 본 약관을 포함하여 회사가 정한 이용 조건 또는 기타 관계 법령을 위반한 경우
 ③ 미성년인 이용자의 법정대리인으로부터 요청이 있을 경우, 회사는 회원의 서비스 이용에 제한을 가할 수 있습니다.`,
    },
    {
      title: "제 8조 (개인정보 보호정책)",
      content: `① 회사는 관계 법령이 정하는 바에 따라 회원의 개인정보를 보호하기 위하여 노력합니다. 회원의 개인정보 보호 및 사용에 대해서는 관계 법령 및 회사가 정하는 개인정보처리방침에 의합니다. 단, 회사의 공식 홈페이지 이외의 링크된 사이트에서는 회사의 위 개인정보처리방침이 적용되지 않습니다.
② 회사는 회원의 귀책사유로 인해 노출된 정보에 대해서는 일체의 책임을 지지 않습니다. 다만, 회사가 고의 또는 중과실로 손해가 발생한 경우에는 그러하지 않습니다.`,
    },
    {
      title: "제 9조 (정보의 제공 및 광고의 게재)",
      content: `① 회사는 서비스 운영과 관련하여 서비스 내에 광고를 게재할 수 있습니다. 또한, 수신에 동의한 회원에 한하여 전자우편, 문자서비스(LMS/SMS) 등의 방법으로 광고성 정보를 전송할 수 있습니다. 이 경우 회원은 언제든지 수신을 거절할 수 있으며, 회사는 회원의 수신 거절 시 광고성 정보를 발송하지 못합니다.
② 이용자는 회사가 제공하는 서비스 중 배너 등에 게재된 광고 또는 서비스 내 링크를 통해 광고주의 판촉활동에 연결될 수 있습니다.
③ 전항에 따라 타인이 제공하는 광고나 서비스에 연결될 경우, 해당 영역에서 제공하는 서비스는 회사의 서비스 영역이 아니므로 회사가 신뢰성, 안정성 등을 보장하지 않으며, 그로 인한 회원의 손해에 대하여도 회사는 책임을 지지 않습니다. 다만, 회사가 고의 또는 중과실로 손해의 발생을 용이하게 하거나 손해 방지를 위한 조치를 취하지 아니하는 경우에는 그러하지 않습니다.`,
    },
    {
      title: "제 10조 (회사의 서비스에 대한 결제)",
      content: `① 회사는 다음 각 호에 해당하는 경우 서비스의 전부 또는 일부를 제한하거나 중지할 수 있습니다.
1. 전기통신사업법에 규정된 기간통신사업자가 전기통신 공급을 중지하였을 경우
2. 설비의 보수, 정기점검 등 회사의 필요에 의한 경우
3. 정전, 제반 설비의 장애 또는 이용량의 폭주 등으로 정상적인 서비스 이용에 지장이 있는 경우
4. 천재지변, 국가비상사태 등 불가항력적인 사유가 있는 경우
5. 기타 회사의 업무상이나 계약상, 기술상의 이유로 서비스의 전부 또는 일부 중지가 필요하다고 판단되는 경우
② 서비스 정지가 필요할 경우 회사는 본 이용약관에서 정한 방법으로 회원에게 사전 통지합니다. 단, 버그, 오류 등의 수정이나 회사가 통제할 수 없는 사유로 인하여 불가피한 경우에는 서비스의 전부 또는 일부를 중지한 후 해당 사실을 사이트에 사후 공지할 수 있습니다.
③ 회사는 본 조 제1항의 사유로 서비스의 제공이 일시적으로 중단됨으로 인하여 회원의 손해에 대하여 책임지지 않습니다.`,
    },
    {
      title: "제 11조 (음반의 등록 및 리슨 등록)",
      content: `① 회원은 사이트에서 제공하는 기능을 사용하기 위한 목적으로 음반을 등록할 수 있으며, 등록한 음악은 모두 리슨에 등록됩니다.
② 회원은 등록된 음반이 플플에 등록된 플레이리스트 크리에이터가 플레이리스트 수록 목적으로 사용하는 것에 동의해야 합니다. 회원이 등록한 음반으로 인하여 해당 음반을 수록한 플레이리스트 크리에이터가 제3자로부터 저작권 침해 소송을 당하는 등 법적 분쟁이 발생할 경우, 회원은 자신의 비용과 책임으로 회사와 크리에이터를 면책시켜야 합니다.
③ 회사는 회원이 등록한 음반을 사이트를 운영하는 목적에 한해서 활용 및 이용할 수 있습니다.
④ 크리에이터는 등록된 음반으로 플레이리스트를 자유롭게 제작할 수 있습니다. 다만, 고의 및 악의적으로 음반에 피해를 줄 경우, 이에 대한 법적 책임을 요구받을 수 있습니다.
⑤ 크리에이터는 등록된 음반파일을 사이트에서 내려 받을 수 있습니다. 다만, 플레이리스트 수록, 제작 목적 및 정해진 용도 외에 사용할 경우, 저작권 관련 법적 책임을 부담할 수 있습니다.
⑥ 리슨을 통해 제작된 플레이리스트는 최소 1년간 유지되어야 하며, 사이트에 기재되지 않은 음악으로 인해 플레이리스트가 삭제 혹은 중지될 경우, 해당 음악을 제거 혹은 대체하여 다시 게재하여야 합니다.`,
    },
    {
      title: "제 12조 (리슨 플러스와 포크 이용과 동의)",
      content: `① 회원은 리슨에 등록한 음반을 리슨 플러스에 등록할 수 있으며, 원하는 채널 및 크리에이터를 선택하여 플레이리스트 수록을 피칭할 수 있습니다.
② 리슨 플러스를 통해 음반 수록을 제안받은 크리에이터는 자율적으로 플레이리스트 수록을 결정할 수 있으며, 플레이리스트에 수록하면 리슨 플러스를 제안한 회원으로부터 리워드를 제공받습니다.
③ 리워드의 기준은 사이트에서 제공하는 CPI, PPI를 통해 산정된 리슨 기준 금액입니다.
④ 크리에이터는 리슨 플러스를 제안받고 수록할 경우 14일 이내에 플레이리스트에 수록 및 게재한 후, 온라인에 게재한 플레이리스트의 링크 및 UR을 사이트에 등록하여야 합니다. 등록하지 않을 경우, 리슨 플러스는 자동 취소됩니다.
⑤ 크리에이터는 다른 크리에이터에게 제안된 리슨 플러스 음반을 들어보고 음반을 등록한 회원에게 자신의 플레이리스트에 수록하고 리워드를 받을 수 있는지 제안하는 포크를 할 수 있습니다. 포크를 받은 회원은 수락 여부를 결정할 수 있고, 여기서 '수락'은 다른 크리에이터의 플레이리스트 채널에 수록하고 리워드를 지급받는 것에 동의하는 것을 의미합니다.
⑥ 회원은 리슨 플러스 이용을 위해 캐시를 충전해야 하며, 리슨 플러스를 제안하고 크리에이터가 수록하면 사이트에서 회원이 보유한 캐시에서 차감합니다.
⑦ 크리에이터가 최종적으로 플레이리스트 링크를 사이트에 등록할 경우, 사이트에서 크리에이터에게 리워드 목적으로 캐시를 지급합니다.
⑧ 리슨플러스와 포크는 회원과 크리에이터 간의 거래 및 이용 동의이며 수록 결정, 수락 결정 후에는 환불 및 취소가 불가능합니다.
⑨ 리슨 플러스와 포크를 통해 제작된 플레이리스트는 특별한 사정이 없는 한 최소 1년간 유지되어야 하며, 사이트에 기재되지 않은 음악으로 인해 플레이리스트가 삭제 혹은 중지될 경우, 해당 음악을 제거 혹은 대체하여 다시 게재하여야 합니다.`,
    },
    {
      title: "제 13조 (데이터랩의 이용과 제공)",
      content: `① 회원은 사이트에서 제공하는 CPI, PPI를 포함한 각종 플레이리스트 관련 데이터를 사이트 내에서 자유롭게 사용할 수 있습니다.
② 회원은 사이트에서 개발한 CPI, PPI 모델을 상업적 목적으로 배포 및 재판매할 수 없으며 이를 어길 경우 법적 책임을 물을 수 있습니다.`,
    },
    {
      title: "제 14조 (매거진의 이용과 제공)",
      content: `회원은 사이트에서 제공하는 매거진을 자유롭게 열람할 수 있으며 자유롭게 배포가 가능합니다. 단, 외부에 배포할 경우 본 사이트로부터 발췌하였다는 출처를 명확히 기재해야 합니다.`,
    },
    {
      title: "제 15조 (음반 저작재산권의 양도)",
      content: `① 회원이 특정하는 음반에 대한 저작재산권을 회사로부터 양도받는 경우, 해당 음원에 대한 저작재산권 일체(복제, 공중송신, 배포, 공연, 대여, 2차적 저작물 작성권 등)와 상업적 사용에 어떠한 제한없이 확정적으로 양도받는 것으로 합니다.
② 본조에 의한 음반 저작재산권 양도계약 체결을 위하여 회원은 양도 대상인 음악저작권의 권리 등록 또는 이전에 필요한 서류의 작성 및 전달에 협조하여야 합니다.
③ 본조에 의한 음반 저작재산권 양도계약이 체결되는 경우, 회사는 양도대상이 된 음반 저작재산권의 전부 또는 일부를 제3에게 제공 또는 이용하거나 권리설정 계약을 체결하는 등으로 회원에게 이전된 음반 저작재산권에 영향을 주는 행위를 하지 않습니다.
④ 회사는 본조에 의하여 체결된 음반 저작재산권 양도계약의 대상이 된 저작물이 타인의 저작권을 침해하지 아니함을 보증하지 않으며, 회원의 음반 등록 시 표절 여부 등을 검사하지 아니합니다. 단, 회사가 고의 또는 중과실로 저작재산권을 양도받은 회원에게 손해를 입힌 경우에는 이를 배상하여야 합니다.
⑤ 본조에 의한 음반 저작재산권 양도가액은 회원이 음반 판매등록시에 직접 입력한 판매 가격으로 정합니다.`,
    },
    {
      title: "제 16조 (음반 저작재산권 양도 계약의 해제, 해지 및 손해배상)",
      content: `① 회사가 본 약관 내용 또는 회원과 별도 합의한 사항을 위반하고, 회원이 이에 대한 시정조치를 서면으로 요청하였음에도 불구하고 10영업일 이내에 시정이 이루어지지 아니하는 경우 회원은 음반 저작재산권 양도 계약을 해제 또는 해지할 수 있습니다.
② 회원이 본 약관 내용 또는 회원과 별도 합의한 사항을 위반하는 경우, 회사는 음반 저작재산권 양도계약을 해제 또는 해지할 수 있습니다.
③ 본조의 양도계약 해제, 해지는 손해배상의 청구에 영향을 주지 아니합니다.`,
    },
    {
      title: "제 17조 (음원 유통 계약의 체결)",
      content: `회원이 저작재산권을 보유한 음원에 대한 음반 발매 내지 디지털 음원 유통을 회사에 의뢰하는 경우, 구체적인 계약 조건 및 내용은 본 이용약관에 첨부된 디지털 음원유통 계약 및 디지털 콘텐츠 유통약관에서 정하는 바에 의합니다.`,
    },
    {
      title: "제 18조 (유튜브 서비스 이용에 대한 동의)",
      content: `① 회원은 음반 등록 시, 유튜브에 등록된 음반 링크를 기재하여야 하고, 사이트에서 이를 활용하여 사이트를 운영하는 것에 동의해야 합니다.
② 유튜브 음반 링크는 음반과 앨범 커버 이미지 등록 후 판매 등록을 완료할 경우 자동 생성되며, 해당 기능 사용과 관련하여 유튜브 이용 약관(유튜브 이용 약관)을 확인하고 동의하여야 합니다.
③ 회원은 회사에서 명시하는 유튜브의 이용 약관을 확인하고, 이에 동의 하에 서비스를 이용해야 합니다.`,
    },
    {
      title: "제 19조 (전자지갑, NFT 및 NFT음반)",
      content: `"NFT(Non-fungible token, 대체불가능토큰)"란 블록체인 기술을 이용하여 디지털 자산의 소유주를 증명하는 가상의 토큰입니다. "NFT음반"이란 사이트에서 거래되는 음반의 NFT를 발행한 상품입니다. 위 NFT와 관련한 회사와 회원의 권리의무 관계는 다음과 같습니다.
1. NFT음반 발행 및 거래는 회사에서 지정한 오픈마켓을 통해 이루어져야하며, 회사가 직접 암호화폐 발행, 오픈마켓 개설 등을 통해 NFT발행 및 NFT거래 주체가 될 경우, 뮤지션과 회원은 회사의 제공 환경에서 NFT음반 발행, 등록 및 거래해야합니다.
2. 뮤지션은 음반 판매 등록 시, 음반의 원작자로써 NFT를 발행해야합니다. 음반에 대한 NFT는 직접 발행 후 사이트에 등록하거나 회사에 발행 대행을 요청할 수 있습니다.
3. 회사는 뮤지션의 요청에 따라 NFT를 발행 및 사이트에 등록해야하며, 발행 대행을 통해 등록 된 NFT에서 수수료 수익이 발생할 경우 발행 대행 수수료 50%를 제외 후 뮤지션에 정산합니다.
4. NFT 발행은 NFT오픈마켓 오픈씨(Opensea.io)를 통해 폴리곤 기반으로 발행해야합니다. 오픈씨와 폴리곤을 제외한 타 플랫폼, 기술, 암호화폐 사용으로 인한 불이익과 책임은 뮤지션에게 있습니다.
5. 회원은 사이트에 오픈씨에서 사용가능한 전자지갑 주소를 등록해야만 NFT를 전달(Transfer)받을 수 있으며, 오픈씨에서 사용불가능한 전자지갑을 등록하거나 전자지갑 정보가 등록되어있지 않을 경우 회사는 회원이 전자지갑 정보를 등록할 때까지 전달(Transfer)를 연기할 수 있습니다.
6. 회원이 사이트에서 구매한 NFT음반을 n차 판매할 경우, 회사는 해당 NFT음반 구매자의 요청에 따라 권리 이전 절차를 진행하며 판매자인 회원은 회사의 거래 확인 요청에 응답해야합니다. 단, 거래당사자는 회사가 지정한 오픈마켓에서 거래해야하며, 회사는 해당 오픈마켓을 통한 거래에 한해서 권리 이전 서비스를 제공합니다.
7. NFT음반의 n차 판매 구매자는, 권리 이전과 저작인접권료 수령을 위해 사이트 회원가입 후 권리 이전 신청 접수(https://forms.gle/xafggC1gjHn2izvXA)를 통해 구매한 음반의 사이트 상의 이전 권리를 신청해야합니다. 회사는 권리 이전 신청 접수 후 영업일 기준 7일 이내에, 판매자인 회원과 거래 여부를 확인 후 권리 이전을 진행해야합니다. 권리 이전 신청을 하지 않음으로서 발생하는 문제는 거래당사자인 구매자에게 있으며, 회사는 책임지지 않습니다.
8. 회사는 사이트 외의 시스템, 전자지갑, NFT오픈마켓에서 발생하는 문제와 불이익에 대해서 책임지지 않습니다.
9. 권리 이전 완료 후에도 음원 플랫폼에 발매 시 기재 된 레이블명은 변경되지 않습니다.
10. 저작인접권료는 회사가 정한 정산 기준에 따릅니다. 정산 기준은 아래 <거래일에 따른 저작인접권료 정산 대상 기준>표를 참조합니다. 15일과 말일이 토요일 혹은 공휴일 일 경우 이전 영업일을 기준일이 변경됩니다.
<거래일에 따른 저작인접권료 정산 대상 기준>
정산 대상 (일) / 거래일 / 정산 대상
해외정산 (15일) / 매월 1일~15일 전 / 15일 NFT음반 소유자
국내정산 (말일) / 매월 16일~말일 / 말일 NFT음반 소유자
11. NFT음반 n차 거래 시 발생하는 수수료, 불이익, 수익과 관련 문제에 대한 책임은 거래 당사자에게 있으며, 회사는 책임지지 않습니다.
12. NFT음반 n차 거래를 통해 권리 이전 완료되어도, 구매자는 음반 유통사를 변경할 수 없으며 기존 디지털 음원 유통 약관에 따라 회사와의 유통 계약 관계를 유지해야합니다.`,
    },
    {
      title: "제 20조 (플플 멤버십)",
      content: `① 플플 멤버십은 회사에서 제공 및 판매하는 음반을 재구성하여 플레이리스트 제작 및 유튜브 플레이리스트 채널에 업로드를 제공하는 구독형 멤버십 상품입니다. 회원은 플플 멤버십 상품 이용을 위해, 회사에게 제공받은 음반을 활용하여 플레이리스트를 제작하여 유튜브 채널에 업로드를 요청할 수 있으며, 회사는 요청한 회원에게 회사에서 정한 일정 금액을 추가로 지급받고 플레이리스트 제작 및 업로드 서비스를 제공하는 것을 뜻합니다.
② 해당 상품은 회사에서 지정한 뮤지션과 앨범 형태로 통해 음반이 지급 및 발매되며, 각 앨범 중 회원이 소유한 음반 트랙에 대한 스트리밍 로열티 권리를 회원이 멤버십 유지 기간 동안 보유합니다. 단, 해지시 음반 스트리밍 로열티 권리는 회사에 회수되며, 제작 및 제공 된 플레이리스트에 대한 수익 청구권은 회원에게 유지됩니다.
③ 회원은 해당 상품 이용을 위해 정기 구독 결제가 가능한 신용 및 체크카드를 정기 구독 결제 수단으로 등록해야 하며, 정상적인 서비스 이용 및 권리 확보를 위해 회사가 지정한 날짜에 결제가 진행되야 합니다.
④ 회원은 중도에 구독 취소(결제 취소)가 가능하며, 이 경우 회사는 회원이 실제 이용한 기간에 해당하는 요금을 차감하고 환불하여야 합니다.
⑤ 회원이 멤버십을 해지 및 연장하지 않을 경우, 회사가 지정하는 사이트에서 발생한 수익에 대한 정산이 중단됩니다. 단, 플레이리스트에서 발생하는 수익은 멤버십 해지 후에도 정산합니다.
⑥ 회사는 해당 상품의 서비스 내용을 회원에게 고지 후 변경할 수 있습니다.`,
    },
    {
      title: "제 21조 (회사의 서비스에 대한 결제)",
      content: `① 회원이 사이트에서 제공하는 서비스를 위해 금원을 지불하는 결제는 다음 각호의 방식에 의합니다. 단, 회사의 사정상 일부 결제수단이 제한될 수 있습니다.
1. 폰 뱅킹, 인터넷 뱅킹, 메일 뱅킹 등 각종 계좌이체
2. 선불카드, 직불카드, 신용카드 등의 각종 카드결제
3. 온라인 무통장 입금
4. 회사가 계약을 맺었거나 회사가 인정한 상품권에 의한 결제
5. 기타 전자적 지급방법에 의한 대금지급
② 상기 각 결제수단을 운영하는 결제대행 사업자[개인정보처리방침]이 별도로 있는 경우, 이용자는 해당 결제수단을 이용하기 전에 해당 결제대행 사업자가 제시하는 절차를 이행하여야 합니다.
③ 무통장입금 방식으로 납부할 경우 계약체결 후 1주일 이내에 해당 금액을 입금하여야 하며, 이용자와 입금인이 다를 경우 이용자는 회사에 전화나 이메일, 팩스로 그 내용을 통지해야 합니다. 통지 누락으로 인한 모든 책임은 사용자에게 있습니다.
④ 입금 확인은 특별한 사정이 없는 한, 회사의 영업 시간(평일 근무일, 월∼금, 오전 10시∼ 오후6시)내에 이루어지며, 영업종료 후의 입금은 익일 영업 시간 내 처리 완료됩니다.`,
    },
    {
      title: "제 22조 (환급)",
      content: `회사는 회원이 신청한 유료서비스를 품절 등의 사유로 인도 또는 제공할 수 없는 경우에는 지체 없이 그 사유를 회원에게 통지하고 사전에 유료 서비스 이용요금을 받은 날부터 5 영업일 이내에 환급하거나 환급에 필요한 조치를 취하여야 합니다.`,
    },
    {
      title: "제 23조 (청약철회 등)",
      content: `① 회사와 플플 멤버십 등 유료서비스 이용에 관한 계약을 체결한 회원은 구매일 또는 유료서비스 이용가능일로부터 7일 이내에는 청약의 철회(결제취소)를 할 수 있습니다.
② 제1항에도 불구하고, 회원은 다음 각 호의 어느 하나에 해당하는 경우에는 회사의 의사에 반하여 제1항에 따른 청약철회 등을 할 수 없습니다.
1. 회원에게 책임이 있는 사유로 서비스 등이 멸실되거나 훼손된 경우
2. 회원이 서비스를 사용 또는 일부 소비한 경우
3. 시간의 경과에 의하여 다시 판매하기 곤란한 경우
4. 그 밖에 거래의 안전을 위하여 법령으로 정하는 경우
③ 회사는 제2항 제2호 내지 제3호의 경우에 따라 청약철회가 불가능한 유료 서비스의 경우에는 그 사실을 회원이 쉽게 알 수 있는 곳에 명확히 적시하여야 합니다. 만약 회사가 이러한 조치를 하지 아니한 경우에는 제2항의 청약철회 제한사유에도 불구하고 회원은 청약철회를 할 수 있습니다.
④ 회원은 제1항 내지 제3항의 규정에도 불구하고, 유료 서비스의 내용이 표시, 광고 내용과 다르거나 계약내용과 다르게 이행된 경우에는 구매일 또는 유료 서비스 이용 가능일로부터 3월 이내, 그 사실을 안 날 또는 알 수 있었던 날로부터 30일 이내에 청약철회를 할 수 있습니다.
⑤ 청약철회는 회원이 전화, 전자우편 등의 방법으로 할 수 있으며, 회사에 의사를 표시하여 회사에 도달한 때 그 효력이 발생하고, 회사는 회원의 의사표시를 수령한 후 지체 없이 이러한 사실을 회원에게 회신하여야 합니다.`,
    },
    {
      title: "제 24조 (청약철회 등의 효과)",
      content: `① 회사는 전조 제1항에 의한 청약철회가 된 경우 3 영업일 이내에 이미 지급받은 대금을 환급하여야 합니다. 이 경우 회사가 회원에게 대금의 환급을 지연한 때에는 그 지연기간에 대하여 전자상거래 등에서의 소비자보호에 관한 법률 시행령 제21조의3에서 정한 지연이자율(100분의 15)를 곱하여 산정한 지연이자를 지급합니다.
② 회원이 유료 서비스 이용계약을 중도해지한 경우, 회사는 회원이 구매한 대금에서 회원이 실제 이용한 기간 등 서비스 제공기간에 해당하는 요금을 차감하고 환불하여야 합니다. 단, 회원이 프로모션/이벤트를 통해 무상으로 이용권을 취득하는 등 회원이 직접 비용을 지불하지 아니한 서비스에 대하여는 회사가 환불의무를 부담하지 아니합니다.
③ 회사는 위 대금을 환급함에 있어 회원이 신용카드 또는 전자화폐 등의 결제수단으로 유료 서비스 이용대금을 지급한 때에는 지체 없이 당해 결제수단을 제공한 사업자로 하여금 대금의 청구를 정지 또는 취소하도록 요청합니다.
④ 청약철회의 경우 대금반환에 필요한 비용은 회원이 부담합니다. 회사는 회원에게 청약철회 등을 이유로 위약금 또는 손해배상을 청구하지 아니합니다. 다만, 유료서비스 등의 내용이 표시, 광고 내용과 다르거나 계약내용과 다르게 이행되어 청약철회 등을 하는 경우 대금반환에 필요한 비용은 회사가 부담합니다.`,
    },
    {
      title: "제 25조 (양도금지)",
      content: `회원은 본 약관에 기한 지위 및 권한을 회사의 사전 승인 없이 제3자에게 양도 및 위임하거나 담보제공 등의 목적으로 처분할 수 없습니다.`,
    },
    {
      title: "제 26조 (회사의 의무)",
      content: ` ① 회사는 관계 법령과 본 약관이 정하는 바에 따라 회원에게 지속적, 안정적으로 서비스를 제공하여야 합니다.
② 천재지변 등 예측하지 못한 일이 발생하거나 시스템의 장애가 발생하여 서비스가 중단될 경우에는 회사가 책임을 지지 않습니다. 다만, 회사는 자료의 복구나 정상적인 서비스 지원이 가능하도록 최선을 다할 의무를 부담합니다.
③ 회사는 회원이 안전하게 서비스를 이용할 수 있도록 회원의 개인정보보호를 위한 보안 시스템을 구축하여야 합니다.
④ 회사는 회원으로부터 제기되는 의견이나 불만이 정당하다고 객관적으로 인정될 경우에는 적절한 절차를 거쳐 즉시 처리하여야 합니다. 다만, 즉시 처리가 곤란한 경우에는 회원에게 그 사유와 처리 일정을 통보하여야 합니다.
⑤ 회사는 이용계약의 체결, 계약사항의 변경 및 해지 등 회원과의 계약관계 절차 및 내용 등에 있어 회원에게 편의를 제공하도록 노력합니다.`,
    },
    {
      title: "제 27조 (회원의 의무)",
      content: ` ①회원은 회원가입 신청 시 모든 사항을 사실에 근거하여 기재하여야 하며, 허위 또는 타인의 정보를 등록할 경우 일체의 권리를 주장할 수 없습니다.
 ② 회원은 회사가 제공하는 서비스를 이용함에 있어 다음 각 호의 행위를 하여서는 안됩니다. 
 1. 가입신청이나 회원 정보 변경 시 허위사실을 기재하거나, 타인의 개인정보, 이용자ID 및 비밀번호를 부정하게 사용하는 행위
 2. 같은 이용자가 다른 ID로 이중등록 하거나 ID를 타인과 거래하는 행위
 3. 회사의 직원이나 운영자를 가장하거나 사칭하여 또는 타인의 명의를 도용하는 행위
 4. 국익 또는 사회적 공익, 공공질서, 미풍양속에 저해되는 행위
 5. 타인의 명예를 손상시키거나 불이익을 주는 행위를 한 경우
 6. 회사를 통해 발매한 음원에 대하여 음악산업진흥에관한법률 제26조에서 금하는 부정이용행위를 한 경우
 7. 회사의 서비스 정보를 이용하여 얻은 정보를 회사의 사전 승낙 없이 복제 또는 유통시키거나 상업적으로 이용하는 경우
 8. 회사, 다른 회원 또는 제3자의 지적재산권을 침해하는 음원에 대한 유통발매를 신청하는 경우
 9. 해킹행위 또는 바이러스의 유포, 소스코드나 웹사이트에 게시된 정보의 일부분 또는 전체를 임의로 변경하는 행위
10. 타인의 개인정보를 무단으로 수집, 저장, 게시 또는 유포하는 행위
11. 회사의 사전 승낙 없이 서비스 내 또는 웹사이트를 이용하여 판촉활동을 하는 행위
12. 본 약관을 포함하여 회사가 정한 이용 조건 또는 기타 관계 법령을 위반한 경우
 ③ 회원은 가입 당시 기입한 정보에 변경이 발생하면 즉시 그 내용을 회사에 통보하여야 하며, 통보 지연으로 발생한 문제에 대해서는 회사에서 책임을 지지 않습니다.`,
    },
    {
      title: "제 28조 (회원의 아이디와 비밀번호 관리에 대한 의무와 책임)",
      content: `①회원은 회원 아이디 및 비밀번호 관리를 철저히 하여야 합니다.
 ②회원 아이디와 비밀번호의 관리 소홀, 부정 사용에 의하여 발생하는 모든 결과에 대한 책임은 회원 본인에게 있습니다.
 ③회원은 본인이 아이디와 비밀번호를 제3자에게 이용하게 해서는 안되며, 회원 본인의 아이디와 비밀번호를 도난당하거나 제3자가 사용하고 있음을 인지하는 경우에는 즉시 회사에 통보하고, 회사의 안내가 있는 경우 그에 따라야 합니다.
`,
    },
    {
      title: "제29조 (회원에 대한 통지)",
      content: ` 1. 회사는 회원이 회사에 제출한 이메일 주소 또는 연락처(전화번호, 휴대폰번호) 등을 이용해 회원에 대한 통지를 할 수 있습니다.
 2. 회사는 불특정다수 회원에 대한 통지의 경우 홈페이지에 게시함으로써 개별 통지를 갈음할 수 있습니다.`,
    },
    {
      title: "제 30조 (적립금 및 예치금)",
      content: ` ①"적립금"이란 회사를 이용하여 음반을 구매하거나 이벤트/프로모션 등 회사가 정한 기준에 따라 지급하는 회원 포인트를 말합니다. 
② 예치금"이란 고객이 회사에서 상품결제시 현금과 동일한 기능을 하는 보조결제수단으로 취소 및 반품에 따라 발생하는 금액으로 고객의 요청에 따라 회사에 예치해 놓은 금액을 말합니다.
③ 제1항에서 정한 적립금 및 예치금은 다음 각 호의 방법에 따르되, 구체적인 이용방법은 회사의 운영정책에 의합니다.
 1. 적립금은 회사가 운영하는 사이트에서 재화 등 구매 한 후 적립 받은 적립금은 사용 제외 품목 이외에는 현금가액과 동일하게 사용 가능합니다.
 2. 회사는 회원의 사이트 이용 촉진을 위하여 상품구매 또는 이벤트/프로모션 등 회사가 정한 기준에 따라 소정의 적립금을 회원에게 지급하여 드립니다.
 3. 예치금은 회사에 예치하는 예치수단으로 "회원"이 원할 경우 언제든지 사용/환불처리가 가능합니다.
 4. 사이트 적립금 및 예치금은 고객이 회원을 탈퇴한 경우에, 모두 소멸되며 재적립되지 않습니다.
 5. 사이트 적립금 및 예치금은 원칙적으로 타인에게 양도가 불가하며, 동일한 자가 수개의 아이디(ID)를 보유하더라도 각각의 아이디(ID)에 적립된 적립금의 합산 사용은 불가합니다.
 6. 타인의 회원정보 도용으로 인하여 사용된 적립금 및 예치금과 관련하여 회사는 어떠한 책임도 지지 않습니다.
 7. 회사는 회원이 적립금과 예치금을 부적절한 방법으로 적립하였음이 명백하다고 판단된 경우 회원에게 지급한 해당 적립금 및 예치금을 취소하고, 회원의 사이트 이용을 제한할 수 있습니다.
 8. 회사는 회원이 상품을 구매하고 적립금을 지급받은 이후, 구매한 상품을 취소/반품할 경우 지급된 포인트를 취소합니다.
 9. 적립금 유효기간 : 회사로부터 제공받은 적립금의 경우 유효기간은 적립금이 제공된 날을 기준으로 익년 12월 31일까지입니다. 유효기간이 경과한 적립금은 자동적으로 소멸하게 됩니다. 소멸 30일 이전 E-mail로 통지하며, 개인정보 불일치 및 이메일 수신거부시에는 해당내용을 받지 못할 수 있습니다. 
④ 적립금의 전부 혹은 일부를 사용한 상품을 환불하는 경우, 잔여금액에 따라 최초 결제수단대로 환불합니다. 적립금은 어떠한 경우에도 현금화하여 환불하지 않습니다. 
`,
    },
    {
      title: "제 31조 (정산규정)",
      content: ` 회원은 사이트에서 구매한 음반, 멤버십 구독, 플레이리스트 제작 기여 등을 통해 적법하게 제공받은 저작인접권료 청구권 혹은 저작인접권의 저작재산권으로부터 발생하는 수익에 대한 정산을 사이트에서 매월 받을 수 있습니다. 
1. 사이트는 회원에게 각종 음원 스트리밍 사이트 및 영상 플랫폼에서 발생한 수익과 조회수를 제공합니다. 
2. 단, 국내 음원 스트리밍 사이트의 경우 수익 최초 발생 시점으로부터 만 2개월 이후, 해외 음원 스트리밍 사이트 및 영상플랫폼의 경우 최소 만 3개월 이후에 정산받을 수 있습니다. 해당 정산 기간은 각 사이트의 정책에 따르며, 정책의 변경에 따라 사이트의 정산 주기도 변경될 수 있습니다. 
3. 회원은 사업자와 개인에 구분에 따라 부가세와 함께 정산받거나, 제세공과금을 원천징수 후에 정산 받을 수 있습니다.
4. 사이트는 회원에게 수익을 정산하고 국세청에 해당 정산 수익금의 배분을 신고하기 위해 회사의 정보 및 개인 정보를 요구할 수 있으며 정산 목적 외에 이용하지 않습니다. 
5. 정산금에는 회원이 구매한 음반의 판매 조건에 따라 수수료가 부과되며 최대 30%의 정산 수수료가 부과됩니다. 멤버십을 통해 제공받는 음반의 정산 수익은 30%의 정산 수수료가 적용됩니다.
`,
    },
    {
      title: "제 32조 (환불규정)",
      content: ` 회원이 리슨 플러스 이용 목적으로 충전한 캐시의 경우, 직접 결제한 금액의 한도 내에서 환불이 가능합니다. 또한, 회원이 사이트에서 구매한 음반의 저작재산권은 음반 정식 발매일 이전 취소 및 환불 요청시 결제액의 100% 전액 환불이 가능합니다. 다만, 회원의 환불 요청 시, 다음 각 호에 따라 환불 여부에 대한 판단이 달라질 수 있습니다.
 1. 음반 정식 발매는 디지털 음원 사이트에 발매 및 공개되어 사이트의 사용자가 해당 음반을 다운로드 및 스트리밍 혹은 그에 준하는 형태로 청취할 수 있는 상태입니다. 
 2. 음반 정식 발매일은 구매 음반의 따라 상이하며, 디지털 음원 사이트의 정책 및 일정에 따라 변동될 수 있습니다.
 3. 정식 발매 이후에는 환불 및 구매 취소가 불가능합니다. `,
    },
    {
      title: "제 33조 (손해배상)",
      content: ` ① 회사가 본 약관의 규정을 위반한 행위로 회원에게 손해를 입히거나 기타 회사가 제공하는 모든 서비스와 관련하여 회사의 책임 있는 사유로 인해 이용자에게 손해가 발생한 경우 회사는 그 손해를 배상하여야 합니다.
② 회원이 본 약관의 규정을 위반함으로 인하여 회사 및 제3자에게 손해가 발생하게 되는 경우, 약관을 위반한 회원은 그 손해를 전부 배상하여야 합니다.`,
    },
    {
      title: "제 34조 (면책)",
      content: `①회사는 전시, 사변, 국가비상사태, 천재지변, 해결이 곤란한 기술적 결함, 대규모 해킹 기타 불가항력 사유로 서비스를 제공할 수 없는 경우에는 책임을 지지 않습니다.
②회원의 귀책사유로 인한 서비스의 정지 또는 중단, 그 밖의 계약 해지 등에 따른 손해에 대해서 회사는 책임을 지지 않습니다.
③ 회사는 회원이 서비스를 이용하여 기대하는 수익을 얻지 못하거나 손실이 발생한 것에 대하여 책임을 부담하지 않으며, 서비스에 대한 취사선택 또는 이용으로 발생하는 손해 등에 대해서 책임이 면제됩니다.
④ 회사는 회원의 컴퓨터 환경으로 인하여 발생하는 제반 문제 도는 회사의 귀책사유가 없는 네트워크 환경으로 인하여 발생하는 문제에 대해서는 책임을 지지 않습니다.
⑤ 회사는 회원이 서비스 내 또는 웹 사이트에 게시 또는 전송한 정보, 자료, 사실의 신뢰도, 정확성 등 내용에 대해서 보증하지 않습니다.
⑥ 회사는 회원 상호간 또는 회원과 제3자 간에 서비스를 매개로 발생한 분쟁에 대해 개입할 의무가 없으며, 이로 인한 손해를 배상할 책임도 없습니다.`,
    },
    {
      title: "제 35조 (분쟁의 해결 및 준거법)",
      content: ` 1. 회원과 회사는 서비스 이용과 관련해 발생한 문제를 원만하게 해결하기 위해 상호 성실히 협의합니다.
2. 본조 제1항의 협의에도 불구하고, 분쟁으로 인해 소송이 제기될 경우 민사소송법에 따른 관할법원을 통하여 분쟁을 해결합니다.
3. 회사와 회원 간에 제기된 소송에는 대한민국 법을 적용합니다.`,
    },
    {
      title: "시행일",
      content: `본 약관은 2023년 11월 5일부터 시행합니다.`,
    },
  ];

  return (
    <Box bg={bgColor} minH="100vh" py={8}>
      <Container maxW="container.lg">
        <VStack align="start" spacing={8}>
          <Heading as="h1" size="lg" mb={6}>
            이용약관
          </Heading>

          {sections.map((section, index) => (
            <Box key={index} width="100%">
              <Heading as="h2" size="sm" mb={4}>
                {section.title}
              </Heading>
              <Text
                color={textColor}
                whiteSpace="pre-line"
                mb={8}
                fontSize="sm"
              >
                {section.content}
              </Text>
            </Box>
          ))}
        </VStack>
      </Container>
    </Box>
  );
};

export default TermsOfService;
